var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9999 28.4375H9.99988C4.22488 28.4375 3.14988 25.75 2.87488 23.1375L1.93738 13.125C1.79988 11.8125 1.76238 9.875 3.06238 8.425C4.18738 7.175 6.04988 6.575 8.74988 6.575H21.2499C23.9624 6.575 25.8249 7.1875 26.9374 8.425C28.2374 9.875 28.1999 11.8125 28.0624 13.1375L27.1249 23.125C26.8499 25.75 25.7749 28.4375 19.9999 28.4375ZM8.74988 8.4375C6.63738 8.4375 5.18738 8.85 4.44988 9.675C3.83738 10.35 3.63738 11.3875 3.79988 12.9375L4.73738 22.95C4.94988 24.925 5.48738 26.5625 9.99988 26.5625H19.9999C24.4999 26.5625 25.0499 24.925 25.2624 22.9375L26.1999 12.95C26.3624 11.3875 26.1624 10.35 25.5499 9.675C24.8124 8.85 23.3624 8.4375 21.2499 8.4375H8.74988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9999 8.43751C19.4874 8.43751 19.0624 8.01251 19.0624 7.50001V6.50001C19.0624 4.27501 19.0624 3.43751 15.9999 3.43751H13.9999C10.9374 3.43751 10.9374 4.27501 10.9374 6.50001V7.50001C10.9374 8.01251 10.5124 8.43751 9.99994 8.43751C9.48744 8.43751 9.06244 8.01251 9.06244 7.50001V6.50001C9.06244 4.30001 9.06244 1.56251 13.9999 1.56251H15.9999C20.9374 1.56251 20.9374 4.30001 20.9374 6.50001V7.50001C20.9374 8.01251 20.5124 8.43751 19.9999 8.43751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9999 20.9375C11.5624 20.9375 11.5624 18.8125 11.5624 17.5375V16.25C11.5624 14.4875 11.9874 14.0625 13.7499 14.0625H16.2499C18.0124 14.0625 18.4374 14.4875 18.4374 16.25V17.5C18.4374 18.8 18.4374 20.9375 14.9999 20.9375ZM13.4374 15.9375C13.4374 16.0375 13.4374 16.15 13.4374 16.25V17.5375C13.4374 18.825 13.4374 19.0625 14.9999 19.0625C16.5624 19.0625 16.5624 18.8625 16.5624 17.525V16.25C16.5624 16.15 16.5624 16.0375 16.5624 15.9375C16.4624 15.9375 16.3499 15.9375 16.2499 15.9375H13.7499C13.6499 15.9375 13.5374 15.9375 13.4374 15.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4999 18.4625C17.0374 18.4625 16.6249 18.1125 16.5749 17.6375C16.5124 17.125 16.8749 16.65 17.3874 16.5875C20.6874 16.175 23.8499 14.925 26.5124 12.9875C26.9249 12.675 27.5124 12.775 27.8249 13.2C28.1249 13.6125 28.0374 14.2 27.6124 14.5125C24.6874 16.6375 21.2374 18 17.6124 18.4625C17.5749 18.4625 17.5374 18.4625 17.4999 18.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.4999 18.475C12.4624 18.475 12.4249 18.475 12.3874 18.475C8.96239 18.0875 5.62489 16.8375 2.73739 14.8625C2.31239 14.575 2.19989 13.9875 2.48739 13.5625C2.77489 13.1375 3.36239 13.025 3.78739 13.3125C6.42489 15.1125 9.46239 16.25 12.5874 16.6125C13.0999 16.675 13.4749 17.1375 13.4124 17.65C13.3749 18.125 12.9749 18.475 12.4999 18.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jobs.cae0cdfe0e5492b37ef4eeaac13b9a87.svg";